import { render, staticRenderFns } from "./CompanyProducts.vue?vue&type=template&id=098fa44d&"
import script from "./CompanyProducts.vue?vue&type=script&lang=ts&"
export * from "./CompanyProducts.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyProducts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports